<template lang="html">
  <v-layout row wrap>
    <treeselect
      :multiple="true"
      :options="options"
      placeholder="Select your device(s) OR Groups"
      v-model="values"
      @input="updateDevices()"
    />
    <span class="subheading pa-2 font-weight-thin">Select Devices and Groups for current Survey.</span>  
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
// import the styles treeselect
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    Treeselect
  },
  props: {
    round_id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      options: [],
      values: []
    };
  },
  computed: {
    ...mapGetters('survey', ['selectedSurvey']),
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      const url = `rounds/${this.round_id}/tree-devices`;
      window.axios.get(url).then(response => {
        this.options = response.data.tree_select_devices;
        this.values = response.data.selected_devices_round;
        this.$emit('total-devices', this.values.length);
      });
    },
    updateDevices () {
      this.$emit('update-devices', this.values);
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/client/rounds/commons/DevicesSelect.vue